import { Info } from "lucide-react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  CLEANUP_DAYS,
  EXTRA_SIGNAL_POINTS,
  MAX_OVERDUE_POINTS,
  SIGNALS,
  type SignalKind,
} from "./ranking";

// «Slik rangeres listen» (fiks 6, kap. 4.7). Vektene leses fra SIGNALS, den
// samme tabellen rangeringen bruker, så teksten kan ikke gli fra koden.

export const RankingPopover = () => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        className="ml-auto flex items-center gap-1.5 text-[13px] text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
      >
        <Info aria-hidden className="size-3.5" />
        Slik rangeres listen
      </button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-[360px] text-[13px]">
      <div className="flex flex-col gap-3">
        <p className="font-semibold">Slik rangeres listen</p>
        <p className="text-muted-foreground">
          Hver rad får poengene til sitt sterkeste signal, pluss{" "}
          {EXTRA_SIGNAL_POINTS} per ekstra signal og 1 per dag forfalt (maks{" "}
          {MAX_OVERDUE_POINTS}). Høyest poeng står øverst. Ved likt poeng står
          eldste frist først, deretter høyest verdi.
        </p>
        <ul className="flex flex-col gap-1" aria-label="Signaler og poeng">
          {(Object.keys(SIGNALS) as SignalKind[]).map((kind) => (
            <li key={kind} className="flex items-baseline gap-3">
              <span className="min-w-0 flex-1">{SIGNALS[kind].label}</span>
              <span className="shrink-0 text-muted-foreground tabular-nums">
                {kind === "drift" ? "10–20" : SIGNALS[kind].weight}
              </span>
            </li>
          ))}
        </ul>
        <p className="text-muted-foreground">
          Ting som har ligget over {CLEANUP_DAYS} dager, flyttes til «Rydd opp».
          Trykk P eller «Fest øverst i dag» for å låse en rad øverst til
          midnatt.
        </p>
      </div>
    </PopoverContent>
  </Popover>
);
